import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {NgbModule, NgbDateNativeAdapter, NgbDateAdapter} from '@ng-bootstrap/ng-bootstrap';
import {ToggleFullScreenDirective} from './fullscreen/toggle-fullscreen.directive';
import {AccordionAnchorDirective} from './accordion/accordionanchor.directive';
import {AccordionLinkDirective} from './accordion/accordionlink.directive';
import {AccordionDirective} from './accordion/accordion.directive';
import {HttpClientModule} from '@angular/common/http';
import {PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface, PerfectScrollbarModule} from 'ngx-perfect-scrollbar';
import {TitleComponent} from '../layout/admin/title/title.component';
import {CardComponent} from './card/card.component';
import {CardToggleDirective} from './card/card-toggle.directive';
import {ModalBasicComponent} from './modal-basic/modal-basic.component';
import {ModalAnimationComponent} from './modal-animation/modal-animation.component';
import {SpinnerComponent} from './spinner/spinner.component';
import {ClickOutsideModule} from 'ng-click-outside';
import {DataFilterPipe} from './elements/data-filter.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import {TagInputModule} from 'ngx-chips';

import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';


import {
   MatInputModule,
   MatPaginatorModule,
   MatProgressSpinnerModule,
   MatSortModule,
   MatTableModule,
   MatIconModule,
   MatButtonModule,
   MatCardModule,
   MatFormFieldModule,
   MatTreeModule,
   MatCheckboxModule,
   MatDialogModule,
   MatAutocompleteModule,
   MatSnackBarModule,
   MatTabsModule,
   MatBadgeModule,
   MatRadioModule
} from "@angular/material";
import { ToastrModule } from 'ngx-toastr';

import { NgbDateMomentAdapter } from '../_helpers/helperClasses';
import { FormCtrlHelpDirective } from './form-ctrl-help/form-ctrl-help.directive';
import { AlertHelperViewDirective } from './alert-helper-view/alert-helper-view.directive';
import { AutofocusDirective } from './auto-focus/auto-focus.directive';
import { ProfileComponent } from '../theme/_profile/profile.component';
import { ValidationSummaryComponent } from './validation-summary/validation-summary.component'
import { CustomValidatorDirective } from './validation-summary/custom-validator.directive';



const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

@NgModule({
  imports: [
    CommonModule,
    NgbModule.forRoot(),
    HttpClientModule,
    PerfectScrollbarModule,
    ClickOutsideModule,
    ToastrModule.forRoot({ positionClass: 'toast-top-right', closeButton: true, preventDuplicates: true }),
      FormsModule,
    ReactiveFormsModule,
    // Nice Select 2
    NgSelectModule,
    // reluctancy to add Mat
    TagInputModule,
   MatInputModule,
   MatPaginatorModule,
   MatProgressSpinnerModule,
   MatSortModule,
   MatTableModule,
   MatIconModule,
   MatButtonModule,
   MatCardModule,
   MatFormFieldModule,
   MatTreeModule,
   MatCheckboxModule,
   MatDialogModule,
   MatAutocompleteModule,
   MatSnackBarModule,
   MatTabsModule,
    MatBadgeModule, MatRadioModule
    //, ValidationSummaryComponent
    , SweetAlert2Module.forRoot()
   // //=> In submodules only:
   // ,SweetAlert2Module

   // //=> In submodules only, overriding options from your root module:
   // ,SweetAlert2Module.forChild({ /* options */ })
   //// reluctancy to add Mat
  ],
  exports: [
    NgbModule,
    ToggleFullScreenDirective,
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    CardToggleDirective,
    HttpClientModule,
    PerfectScrollbarModule,
    TitleComponent,
    CardComponent,
    ModalBasicComponent,
    ModalAnimationComponent,
    SpinnerComponent,
    ClickOutsideModule,
    DataFilterPipe,
    FormsModule,
    ReactiveFormsModule,
     // reluctancy to add Mat
   MatInputModule,
   MatPaginatorModule,
   MatProgressSpinnerModule,
   MatSortModule,
   MatTableModule,
   MatIconModule,
   MatButtonModule,
   MatCardModule,
   MatFormFieldModule,
   MatTreeModule,
   MatCheckboxModule,
   MatDialogModule,
   MatAutocompleteModule,
   MatSnackBarModule,
   MatTabsModule,
    MatBadgeModule,MatRadioModule
   // reluctancy to add Mat
    , ToastrModule
    // Nice Select 2
    , NgSelectModule
    , TagInputModule
    , FormCtrlHelpDirective, AlertHelperViewDirective
    , AutofocusDirective
    , SweetAlert2Module
    , ValidationSummaryComponent
    , CustomValidatorDirective

  ],
  declarations: [
    ToggleFullScreenDirective,
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    CardToggleDirective,
    TitleComponent,
    CardComponent,
    ModalBasicComponent,
    ModalAnimationComponent,
    SpinnerComponent,
    DataFilterPipe
    , FormCtrlHelpDirective, AlertHelperViewDirective, AutofocusDirective
    , ValidationSummaryComponent
    , CustomValidatorDirective
  ],

  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
    // To Ensure that DataPicker is using Native Javascript Date
    { provide: NgbDateAdapter, useClass: NgbDateNativeAdapter }

  ]
 
})
export class SharedModule { }
